// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__create-method{max-width:1140px;margin:0 auto}.container__create-method .column__create-method{max-width:1140px;display:grid;grid-template-columns:340px 1fr;gap:40px}.container__create-method .side-bar__create-method{display:flex;flex-direction:column}.container__create-method .alert__note{color:#3b3e66;background-color:#e8fbfd;border-color:#11c5db}@media screen and (max-width:768px){.container__create-method .column__create-method{grid-template-columns:1fr}}", ""]);
// Exports
module.exports = exports;
